import { getDexConfig } from '@/utils/getDexConfig'
import { getEnvAndDex } from '@/utils/getEnvAndDex'

const AuthLeftPanel = () => {
  const { dex } = getEnvAndDex()
  const { LandingLogo, HeroCircle, backgroundImage, tagline } = getDexConfig(dex)

  return (
    <div
      className="bg-grey-90 bg-no-repeat bg-center bg-cover max-tablet-p:h-[30vh] overflow-hidden relative w-[60%] max-tablet-p:flex max-tablet-p:items-center max-tablet-p:justify-center max-tablet-p:w-full max-tablet-p:py-11.25 max-tablet-p:px-8"
      style={{ backgroundImage: `url('/img/${backgroundImage}')` }}
    >
      <div className="flex items-center w-full max-w-[16.6875rem] tablet-p:absolute tablet-p:top-19.5 tablet-p:left-12 max-tablet-p:hidden">
        <LandingLogo />
      </div>
      <div className="text-login-gradient absolute top-[40%] left-12 max-tablet-p:left-5 max-w-96 text-[2.5rem] font-[800] leading-12 max-tablet-p:top-1/2 max-tablet-p:-translate-y-1/2 max-tablet-p:max-w-56 max-tablet-p:text-2xl max-tablet-p:leading-8 max-tablet-p:font-semibold">
        {tagline}
      </div>
      {HeroCircle && (
        <div className="absolute bottom-0 left-0 w-[55%] opacity-30 translate-y-0 scale-100 max-tablet-p:w-auto max-tablet-p:origin-bottom-left max-tablet-p:scale-40 max-tablet-p:translate-y-[5%] max-tablet-p:opacity-90">
          <HeroCircle />
        </div>
      )}
    </div>
  )
}

export default AuthLeftPanel
